import React, { Component } from 'react';
import * as firebase from 'firebase';
import styled from 'styled-components';
import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';
import '../../../node_modules/react-accessible-accordion/dist/react-accessible-accordion.css';
import './help-page.css';  

const H3 = styled.h3`
  display: flex;
  align-items: center; 
`

class HelpPage extends Component {
  state = {
    questions: []
  }

  componentWillMount() {
    firebase.database().ref().child('help_questions').on('value', snapshot => {
      const questionList = [];
      snapshot.forEach(q => {
        questionList.push({ ...q.val(), key: q.key });
      })

      this.setState({
        questions:  questionList
      });
    })
  }

  render () {
    return (
      <div>
        <Accordion activeItems={[0]}>
        {this.state.questions.map((q, index) =>  
          <AccordionItem key={q.key} className="accordion__item">
            <AccordionItemTitle>
                <H3 className="u-position-relative">
                    <span style={{ display: 'block', paddingRight: 24 }}>
                      {q.question}
                    </span>
                    <div className="accordion__arrow" role="presentation" />
                </H3>
            </AccordionItemTitle>
            <AccordionItemBody>
                <p>
                  {q.answer}
                </p>
            </AccordionItemBody>
          </AccordionItem>
        )}
        </Accordion>
      </div>
    )
  }
}

export default HelpPage;



// WEBPACK FOOTER //
// ./src/components/Help/HelpPage.js